import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SHA256nymudvmltc47 as SHA256 } from '../../../../hash-library-sha2/org/kotlincrypto/hash/sha2/SHA256.mjs';
import {
  hash1fp34sezu95cc as hash,
  hash2teqor7x28bwm as hash_0,
  hash2jpxxcb5iw7an as hash_1,
  hash2ytqmr282x9qt as hash_2,
  hash1eug6l3wjrtmb as hash_3,
  hashdslf6mgodcq4 as hash_4,
  hash1az8j7xdn0ud6 as hash_5,
  hash2akpkpgdo278y as hash_6,
  hash2ll8ltm3oky5s as hash_7,
  hash1dirvvkne1yvs as hash_8,
} from './Bit32Digest.ext.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { sortedWith2csnbbb21k0lg as sortedWith } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Default_getInstance5ktjwh40tq1j as Default_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/io/encoding/Base64.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function hash_9(_this__u8e3s4, lineItems, itemChanges, punchItems) {
  itemChanges = itemChanges === VOID ? emptySet() : itemChanges;
  punchItems = punchItems === VOID ? emptySet() : punchItems;
  var digest = SHA256().j53();
  hash(digest, _this__u8e3s4.v7a_1);
  hash(digest, _this__u8e3s4.x7a_1);
  hash(digest, _this__u8e3s4.z7a_1);
  hash(digest, _this__u8e3s4.a7b_1);
  hash_0(digest, _this__u8e3s4.b7b_1);
  hash_0(digest, _this__u8e3s4.c7b_1);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = _this__u8e3s4.g7b_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    hash_1(digest, element);
  }
  hash_2(digest, _this__u8e3s4.h7b_1);
  hash_3(digest, _this__u8e3s4.m7b_1);
  hash_4(digest, _this__u8e3s4.r7b_1);
  hash_4(digest, _this__u8e3s4.i7b_1);
  var tmp0_safe_receiver = _this__u8e3s4.k7b_1;
  hash_0(digest, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n5b_1);
  var tmp1_safe_receiver = _this__u8e3s4.k7b_1;
  hash_4(digest, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m5b_1);
  hash_3(digest, _this__u8e3s4.q7b_1);
  hash_5(digest, _this__u8e3s4.z7b_1);
  var tmp2_safe_receiver = _this__u8e3s4.s7b_1;
  hash_3(digest, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.r5f_1);
  var tmp3_safe_receiver = _this__u8e3s4.s7b_1;
  hash_3(digest, tmp3_safe_receiver == null ? null : tmp3_safe_receiver.u5f_1);
  hash_4(digest, _this__u8e3s4.l7b_1);
  hash_0(digest, _this__u8e3s4.u7b_1.a4_1);
  hash_5(digest, _this__u8e3s4.v7b_1);
  hash_5(digest, _this__u8e3s4.w7b_1);
  hash_5(digest, _this__u8e3s4.a7c_1);
  hash_5(digest, _this__u8e3s4.b7c_1);
  hash_5(digest, _this__u8e3s4.c7c_1);
  hash_4(digest, _this__u8e3s4.e7c_1);
  hash_4(digest, _this__u8e3s4.g7c_1);
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = hash$lambda;
  var tmp$ret$2 = new (sam$kotlin_Comparator$0())(tmp);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = sortedWith(lineItems, tmp$ret$2).m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    hash_6(digest, element_0);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = hash$lambda_0;
  var tmp$ret$6 = new (sam$kotlin_Comparator$0())(tmp_0);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = sortedWith(itemChanges, tmp$ret$6).m1();
  while (_iterator__ex2g4s_1.n1()) {
    var element_1 = _iterator__ex2g4s_1.o1();
    hash_7(digest, element_1);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_1 = hash$lambda_1;
  var tmp$ret$10 = new (sam$kotlin_Comparator$0())(tmp_1);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_2 = sortedWith(punchItems, tmp$ret$10).m1();
  while (_iterator__ex2g4s_2.n1()) {
    var element_2 = _iterator__ex2g4s_2.o1();
    hash_8(digest, element_2);
  }
  return Default_getInstance().rq(digest.g51());
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.j9d_1 = function_0;
      }
      wi(a, b) {
        return this.j9d_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.j9d_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function hash$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.e6k_1.toString();
  var tmp$ret$1 = b.e6k_1.toString();
  return compareValues(tmp, tmp$ret$1);
}
function hash$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.v6a_1.toString();
  var tmp$ret$1 = b.v6a_1.toString();
  return compareValues(tmp, tmp$ret$1);
}
function hash$lambda_1(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.j7w_1.toString();
  var tmp$ret$1 = b.j7w_1.toString();
  return compareValues(tmp, tmp$ret$1);
}
//region block: exports
export {
  hash_9 as hash2t85n3abss7t0,
};
//endregion

//# sourceMappingURL=Project.ext.mjs.map
